﻿<script>
	import { getContext } from 'svelte';

    import { registerPageComplete } from "../tealium";
    import { endSurveyPageIndex, pageNumber, currentPage, pageList } from '../stores/pageStore';
	import model from "../stores/modelStore";
	import lookups from "../stores/lookupStore";
	import textStore from "../stores/textStore";
	import { isValid } from "../validation";

    import PageSection from "../components/PageSection.svelte"
    import NavigationButtons from "../components/NavigationButtons.svelte"
    import Form from "../components/Form.svelte"
    import FormRow from "../components/FormRow.svelte"
    import FormColumn from "../components/FormColumn.svelte"
    import RadioGroup from "../components/RadioGroup.svelte"
    import YesNoGroup from "../components/YesNoGroup.svelte"
    import DatePicker from "../components/DatePicker.svelte"

    export let disabled;

    let buttons;
	const { displayError } = getContext("error-modal");
	
	const handleSubmit = async (e) => {
        //e.preventDefault();
		buttons.blockNext();

		if (isValid()) {
			registerPageComplete("General Information",
				$model.Contact.EmailAddress,
				$model.Contact.PhoneNumber,
				$model.ReferralSource);

			let response = await model.saveModelAsync();

			if (!response.success) {
				console.log(displayError)
				displayError(response);
			} else {
				buttons.next();
			}
		}

		buttons.unblock();
	}

    const handleHaveSuperChange = (e) => {
        if (e.target.value === "False") {
            $model.DeathBenefit = null;
            $model.UnableToWork = null;
            $model.OffWorkMonths = null;
            $model.DateLastWorked = null;
        }
    }

    const handleDeathBenefitChange = (e) => {
        if (e.target.value === "False") {
            $model.UnableToWork = null;
            $model.OffWorkMonths = null;
            $model.DateLastWorked = null;
        }
    }

    const handleUnableToWorkChange = (e) => {
        if (e.target.value === "False") {
            $model.OffWorkMonths = null;
            $model.DateLastWorked = null;
        }
    }

    const handleOffWorkMonthsChange = (e) => {
        if (e.target.value === "False") {
            $model.DateLastWorked = null;
        }
    }

    $: {
        $model.GeneralInformationScreenOut = 
            $model.HasSuperFund === "False" ||
            $model.DeathBenefit === "True" ||
            $model.UnableToWork === "False" ||
            $model.OffWorkMonths === "False";

		$model.SurveyComplete = $model.GeneralInformationScreenOut;
    }

	if ($pageNumber == $endSurveyPageIndex) {
		window.location.href = $pageList[0].routeId;
	} else {
		$pageNumber = ($currentPage ? $currentPage.pageIndex : 0);
	}

</script>

{#if $pageNumber == ($currentPage ? $currentPage.pageIndex : 0)}
<PageSection>

	<Form {disabled} id="general-information" on:submit={handleSubmit}>

	    <h1>General Information</h1>

	    <FormRow>
		    <FormColumn>
                <RadioGroup required {disabled}
                    label="How would you like to receive updates from us?"
                    name="contactType"
                    optionList="{$lookups.PreferredContactOptions}"
                    bind:value="{$model.PreferredContactMethod}" />
		    </FormColumn>
	    </FormRow>

	    <FormRow>
		    <FormColumn>
                <YesNoGroup required {disabled}
                    label="{$textStore.doYou} have a super fund, private insurance or other life insurance?"
                    name="haveSuperFunds"
                    bind:value="{$model.HasSuperFund}"
                    on:change={(e) => handleHaveSuperChange(e)} />
		    </FormColumn>
	    </FormRow>

        {#if $model.HasSuperFund == "True"}
    	
	        <FormRow>
		        <FormColumn>
                    <YesNoGroup required {disabled}
                        label="Does your enquiry relate to a Death Benefit only?"
                        name="deathBenefit"
                        bind:value="{$model.DeathBenefit}"
                        on:change={(e) => handleDeathBenefitChange(e)} />
		        </FormColumn>
	        </FormRow>

            {#if $model.DeathBenefit == "False"}

	            <FormRow>
		            <FormColumn>
                        <YesNoGroup required {disabled}
                            label="{$textStore.haveYou} ceased work due to injury or illness?"
                            name="unableToWork"
                            bind:value="{$model.UnableToWork}"
                            on:change={(e) => handleUnableToWorkChange(e)} />
		            </FormColumn>
	            </FormRow>

                {#if $model.UnableToWork == "True"}

	                <FormRow>
		                <FormColumn>
                            <YesNoGroup required {disabled}
                                label="{$textStore.haveYou} been or likely to be off work for 3 months or more?"
                                name="offWorkMonths"
                                bind:value="{$model.OffWorkMonths}"
                                on:change={(e) => handleOffWorkMonthsChange(e)} />
		                </FormColumn>
	                </FormRow>

                    {#if $model.OffWorkMonths == "True"}

	                    <FormRow>
		                    <FormColumn cols="3">
			                    <DatePicker required {disabled}
				                    openOnClass="calendar-pop"
				                    label="What is the date {$textStore.you} last worked?"
				                    bind:formattedSelected={$model.DateLastWorked}
				                    id="dateLastWorked"
				                    start={new Date(2000, 0, 1)}
				                    end={new Date()}
				                    placeholder="e.g. 01/05/1990"
			                    />
		                    </FormColumn>
	                    </FormRow>

                    {/if}

                {/if}

            {/if}

        {/if}

        {#if (!disabled)}
            <div class="form-group form-row">
                <div class="col-md-12 last">
					<NavigationButtons bind:buttons={buttons} />
                </div>
            </div>
        {/if}

    </Form>
</PageSection>
{/if}
